/**
 * Translations for financial terms
 * 
 * Maps English terms to Portuguese (Brazil)
 */

// Revenue types
export const revenueTypeTranslations: Record<string, string> = {
  continuous: 'Contínua',
  single: 'Única',
  installment: 'Parcelada',
  fractional: 'Fracionada',
  CONTINUOUS: 'Contínua',
  SINGLE: 'Única',
  INSTALLMENT: 'Parcelada',
  FRACTIONAL: 'Fracionada',
};

// Expense types
export const expenseTypeTranslations: Record<string, string> = {
  continuous: 'Contínua',
  single: 'Única',
  installment: 'Parcelada',
  CONTINUOUS: 'Contínua',
  SINGLE: 'Única',
  INSTALLMENT: 'Parcelada',
};

// Status translations
export const statusTranslations: Record<string, string> = {
  pending: 'Pendente',
  realized: 'Realizado',
  partially_realized: 'Parcial',
  active: 'Ativo',
  paused: 'Pausado',
  completed: 'Concluído',
  cancelled: 'Cancelado',
  PENDING: 'Pendente',
  REALIZED: 'Realizado',
  PARTIALLY_REALIZED: 'Parcial',
  ACTIVE: 'Ativo',
  PAUSED: 'Pausado',
  COMPLETED: 'Concluído',
  CANCELLED: 'Cancelado',
  VALUE_REACHED: 'Meta Alcançada',
};

// Future expense status translations
export const futureExpenseStatusTranslations: Record<string, string> = {
  active: 'Ativo',
  paused: 'Pausado',
  achieved: 'Alcançado',
  completed: 'Concluído',
  cancelled: 'Cancelado',
  ACTIVE: 'Ativo',
  PAUSED: 'Pausado',
  VALUE_REACHED: 'Meta Alcançada',
  COMPLETED: 'Concluído',
  CANCELLED: 'Cancelado',
};

// Daily expense categories
export const dailyCategoryTranslations: Record<string, string> = {
  food: 'Alimentação',
  transport: 'Transporte',
  leisure: 'Lazer',
  personal: 'Pessoal',
  other: 'Outros',
  FOOD: 'Alimentação',
  TRANSPORT: 'Transporte',
  LEISURE: 'Lazer',
  PERSONAL: 'Pessoal',
  OTHER: 'Outros',
};

// General category translations
export const categoryTranslations: Record<string, string> = {
  housing: 'Moradia',
  transport: 'Transporte',
  food: 'Alimentação',
  health: 'Saúde',
  education: 'Educação',
  leisure: 'Lazer',
  personal: 'Pessoal',
  services: 'Serviços',
  taxes: 'Impostos',
  insurance: 'Seguros',
  investment: 'Investimentos',
  debt: 'Dívidas',
  other: 'Outros',
  HOUSING: 'Moradia',
  TRANSPORT: 'Transporte',
  FOOD: 'Alimentação',
  HEALTH: 'Saúde',
  EDUCATION: 'Educação',
  LEISURE: 'Lazer',
  PERSONAL: 'Pessoal',
  SERVICES: 'Serviços',
  TAXES: 'Impostos',
  INSURANCE: 'Seguros',
  INVESTMENT: 'Investimentos',
  DEBT: 'Dívidas',
  OTHER: 'Outros',
};

/**
 * Translate a term to Portuguese
 * Falls back to original term if no translation found
 */
export function translateTerm(
  term: string | undefined | null,
  translations: Record<string, string>
): string {
  if (!term) return '';
  return translations[term] || translations[term.toUpperCase()] || translations[term.toLowerCase()] || term;
}

/**
 * Translate revenue type
 */
export function translateRevenueType(type: string | undefined | null): string {
  return translateTerm(type, revenueTypeTranslations);
}

/**
 * Translate expense type
 */
export function translateExpenseType(type: string | undefined | null): string {
  return translateTerm(type, expenseTypeTranslations);
}

/**
 * Translate status
 */
export function translateStatus(status: string | undefined | null): string {
  return translateTerm(status, statusTranslations);
}

/**
 * Translate category
 */
export function translateCategory(category: string | undefined | null): string {
  return translateTerm(category, categoryTranslations);
}

/**
 * Translate daily expense category
 */
export function translateDailyCategory(category: string | undefined | null): string {
  return translateTerm(category, dailyCategoryTranslations);
}

/**
 * Translate future expense status
 */
export function translateFutureExpenseStatus(status: string | undefined | null): string {
  return translateTerm(status, futureExpenseStatusTranslations);
}


